.file-uploader {
  position: relative;
  background-color: var(--color-gray-100);

  border-radius: 0.1rem;
  border: 2px dashed var(--color-border-primary);

  &-extra-height {
    height: 20vh;
  }
}

.file-uploader:hover {
  background-color: var(--color-gray-200);
}

.file-uploader-hover {
  // Used to change the uploader color while a user hovers over a file.
  background-color: var(--color-gray-200);
}

.file-uploader input {
  position: absolute;
  top: 0;
  height: 100%;
  border: none;
  opacity: 0;
}

.file-uploader-instruction {
  display: flex;
  padding: 15px;
  text-align: center;
  height: 100%;
  font-size: 1.3rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;
}

.upload-icon {
  transform: scale(1.8);
}
